import React from "react";
import { twMerge, twJoin } from "tailwind-merge";

export interface ModeButtonProps {
  className?: string;
  modes?: [string, string];
  onChange?: (mode: string) => void;
}

const MODE_STYLES = ["bg-secondary text-neutral-600", "bg-neutral-600 text-secondary rounded-r-full border-0.5 border-neutral-600"];

export function SupModeButton({ className, modes = ["light", "dark"], onChange }: ModeButtonProps) {
  const handleChange = (mode: string) => () => {
    onChange?.(mode);
  };

  return (
    <span className={twMerge("sup-mode-button inline-flex h-10 w-20", className)}>
      {modes.map((mode, i) => (
        <span
          key={mode}
          tabIndex={0}
          className={twJoin("flex-1 border-t-0.5 border-b-0.5 border-l-0.5 border-current cursor-pointer", MODE_STYLES[i])}
          onClick={handleChange(mode)}
        />
      ))}
    </span>
  );
}
